/**
 * Shim for @clariness/dropdown: re-exports with optional placeholder (and pointer props)
 * so React 19 / theme-ui types align with usage.
 */
import React from 'react';
import {
  Dropdown as OrigDropdown,
  type DropdownProps as OrigDropdownProps,
} from '~clariness-dropdown';

export type DropdownProps = OrigDropdownProps & {
  placeholder?: string;
  onPointerEnterCapture?: React.PointerEventHandler;
  onPointerLeaveCapture?: React.PointerEventHandler;
  crossOrigin?: string;
};

export const Dropdown = OrigDropdown as React.FC<
  React.PropsWithChildren<DropdownProps>
> & { Option: typeof OrigDropdown.Option };
